/**
 * Chuẩn hóa tên nhà điều hành hiển thị: ưu tiên field API, fallback tra cứu theo danh sách Select.
 * `bookmarkers`: mảng { value | key, label } từ API BOOKMAKER.
 */
export function resolveBookmakerDisplayName(item, bookmarkers) {
  if (!item) return "";
  const direct =
    item.bookmarkerName ??
    item.bookMarkerName ??
    item.bookmakerName ??
    item.bookmaker?.name ??
    item.bookmarker?.name ??
    "";
  if (direct) return String(direct);

  const id =
    item.bookmarkerId ??
    item.bookMakerId ??
    item.bookmakerId ??
    item.bookmaker?.id ??
    item.bookmarker?.id;
  if (id == null || id === "" || !Array.isArray(bookmarkers)) return "";

  const found = bookmarkers.find(
    (b) =>
      b &&
      (b.value === id || b.key === id || String(b.value) === String(id))
  );
  return found?.label != null ? String(found.label) : "";
}
